import { getCookie } from "@/lib/cookies";
import da from "@/lib/i18n/locales/da/translation.json";
import de from "@/lib/i18n/locales/de/translation.json";
import en from "@/lib/i18n/locales/en/translation.json";
import sv from "@/lib/i18n/locales/sv/translation.json";
import { useConfigStore } from "@/store/use-config-store";
import { getShortLngFromCulture } from "@/utils/get-short-lng";

export const PORTAL_TITLE_BY_LNG: Record<string, string> = {
  sv: "Bokningsportal",
  en: "Bookingportal",
  da: "Bookingsportal",
  de: "Buchungsportal"
};

export const PORTAL_DESCRIPTION_BY_LNG: Record<string, string> = {
  sv: "Boka dina kurser och pass enkelt",
  en: "Easily book your courses and sessions",
  da: "Book dine kurser og pass nemt",
  de: "Buche deine Kurse und Einheiten einfach"
};

const svCatalog = sv as Record<string, string>;
const catalogs: Record<string, Record<string, string>> = {
  sv: svCatalog,
  en: en as Record<string, string>,
  da: da as Record<string, string>,
  de: de as Record<string, string>
};

let detailEntityName: string | null = null;

export function getDetailEntityName(): string | null {
  return detailEntityName;
}

export function setDetailEntityName(name: string | null): void {
  detailEntityName = name && name.trim() !== "" ? name.trim() : null;
}

export function clearDetailEntityName(): void {
  detailEntityName = null;
}

export function tStatic(key: string): string {
  const lng = getShortLngFromCulture(getCookie("shop-culture"));
  const catalog = catalogs[lng] ?? svCatalog;
  return catalog[key] ?? svCatalog[key] ?? key;
}

export function manifestDisplayName(data: unknown): string | null {
  if (typeof data !== "object" || data === null || !("name" in data)) {
    console.warn("Manifest name missing");
    return null;
  }
  const name = (data as { name: unknown }).name;
  if (typeof name !== "string" || name.trim() === "") {
    console.warn("Manifest name is not a usable string");
    return null;
  }
  return name.trim();
}

function documentBrandName(): string {
  const { manifestName, settings } = useConfigStore.getState();
  const fromManifest = manifestName?.trim();
  if (fromManifest) return fromManifest;
  return settings?.shopName?.trim() ?? "";
}

export function formatAppTitle(entityName?: string | null): string {
  const lng = getShortLngFromCulture(getCookie("shop-culture"));
  const portal = PORTAL_TITLE_BY_LNG[lng] ?? PORTAL_TITLE_BY_LNG.sv;
  const tenant = documentBrandName();
  const base = `${tenant} ${portal}`.trim();
  const name = entityName?.trim();
  if (!name) return base;
  return `${name} - ${base}`;
}

export function appTitleFromKey(key: string): string {
  return formatAppTitle(tStatic(key));
}

export function appTitleHead(key: string) {
  return {
    meta: [{ title: appTitleFromKey(key) }]
  };
}

export function appDetailTitleHead(fallbackKey: string) {
  return {
    meta: [{ title: formatAppTitle(getDetailEntityName() ?? tStatic(fallbackKey)) }]
  };
}
